<template>
  <!--
    Lays out the information owner_view.partial is built from, grouped so it can be scanned: who
    the owner is, how they are identified, and how to reach them. partial concatenates the name,
    rekno, id number, cell, email, postal address and company - matching on any of those, so each
    is shown. The primary key is given in brackets rather than the legacy rekno reference.
  -->
  <div class="flex flex-col gap-0.5 leading-tight py-0.5">
    <!-- Who -->
    <div class="font-semibold">
      <span v-if="ownerName">{{ ownerName }}</span>
      <span v-else class="italic text-gray-400">Owner {{ props.data.Id }}</span>
      <span v-if="props.data.Id" class="ml-1 font-normal text-gray-400">
        (Owner {{ props.data.Id }})
      </span>
      <span v-if="props.data.PartyType" class="ml-1 font-normal text-gray-400">
        &middot; {{ props.data.PartyType }}
      </span>
    </div>

    <!-- How they are identified -->
    <div v-if="identifiers" class="text-sm text-gray-500">
      {{ identifiers }}
    </div>

    <!-- How to reach them -->
    <div v-if="contact" class="text-sm text-gray-400">
      {{ contact }}
    </div>

    <div v-if="postalAddress" class="text-sm text-gray-400">
      {{ postalAddress }}
    </div>

    <div v-if="props.data.CompanyDescription" class="text-sm text-gray-400">
      {{ props.data.CompanyDescription }}
    </div>
  </div>
</template>

<script setup lang="ts">
interface AuxInputProps {
  data: any;
}

const props = defineProps<AuxInputProps>();

const join = (parts: any[], separator: string) =>
  parts
    .map((p) => (p == null ? "" : String(p).trim()))
    .filter((p) => p !== "")
    .join(separator);

// owner_view exposes Names (plural) and Surname.
const ownerName = computed(() =>
  join([props.data?.Names, props.data?.Surname], " ")
);

const identifiers = computed(() => {
  const parts = [];
  if (props.data?.Rekno) parts.push(`Account: ${props.data.Rekno}`);
  if (props.data?.IdNumber) parts.push(`ID: ${props.data.IdNumber}`);
  return parts.join(" | ");
});

const contact = computed(() => {
  const parts = [];
  if (props.data?.CellPhoneNumber)
    parts.push(`Cell: ${props.data.CellPhoneNumber}`);
  if (props.data?.EMailAddress) parts.push(props.data.EMailAddress);
  return parts.join(" | ");
});

const postalAddress = computed(() =>
  join(
    [
      props.data?.PostalAddressLine1,
      props.data?.PostalAddressLine2,
      props.data?.PostalAddressLine3,
      props.data?.PostalAddressCode,
    ],
    ", "
  )
);
</script>

<style scoped></style>
